import { useTranslation } from "react-i18next";
import CompareStripedRows from "./CompareStripedRows";
import { V1Clinic } from "../../types/v1_schemas";

function HoursTable({
  providerA,
  providerB,
}: {
  providerA: V1Clinic;
  providerB: V1Clinic;
}) {
  const { t } = useTranslation();

  let retArray = [];
  retArray.push({ 
    label: t('hoursValuesmonday'),
    compareA: providerA.hoursOfOperationMonday as string | boolean,
    compareB: providerB.hoursOfOperationMonday as string | boolean
  });
  retArray.push({ 
    label: t('hoursValuestuesday'),
    compareA: providerA.hoursOfOperationTuesday as string | boolean,
    compareB: providerB.hoursOfOperationTuesday as string | boolean
  });
  retArray.push({ 
    label: t('hoursValueswednesday'),
    compareA: providerA.hoursOfOperationWednesday as string | boolean,
    compareB: providerB.hoursOfOperationWednesday as string | boolean
  });
  retArray.push({ 
    label: t('hoursValuesthursday'),
    compareA: providerA.hoursOfOperationThursday as string | boolean,
    compareB: providerB.hoursOfOperationThursday as string | boolean
  });
  retArray.push({ 
    label: t('hoursValuesfriday'),
    compareA: providerA.hoursOfOperationFriday as string | boolean,
    compareB: providerB.hoursOfOperationFriday as string | boolean
  });
  retArray.push({ 
    label: t('hoursValuessaturday'),
    compareA: providerA.hoursOfOperationSaturday as string | boolean,
    compareB: providerB.hoursOfOperationSaturday as string | boolean
  });
  retArray.push({ 
    label: t('hoursValuessunday'),
    compareA: providerA.hoursOfOperationSunday as string | boolean,
    compareB: providerB.hoursOfOperationSunday as string | boolean
  });

  return <CompareStripedRows rows={retArray} title={t("hours")} />;
}

export default HoursTable;
